import React from "react";
import Styles from "../styles.module.scss";

interface IVenueLogoProps {
  venueLogoUrl: string;
}

export function VenueLogo({ venueLogoUrl }: IVenueLogoProps) {
  return (
    <div className={Styles.logo}>
      <img src={venueLogoUrl} alt="venue_brand" />
    </div>
  );
}
